import { writable } from 'svelte/store';
import collect from 'collect.js';
import config from '@/config.js';
// Models
import ParentMarket from '@/Models/ParentMarket.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	const { subscribe, set, update } = writable(collect());

	const methods = {
		getParentMarketsForSport(sportId) {
			if (!config.SPORT_ENABLED) return;

			const parentMarket = new ParentMarket();
			parentMarket.resourceUrl = () => {
				return `${parentMarket.baseUrl()}/sports/${sportId}/${parentMarket.resourceName()}`;
			};

			return parentMarket.get().then((result) => {
				set(result.data.sortBy('order'));
			});
		},

		searchParentMarketsForCompetition(keyword, competitionId) {
			const parentMarket = new ParentMarket();

			parentMarket.where('search', keyword);

			parentMarket.resourceUrl = () => {
				return `${parentMarket.baseUrl()}/competitions/${competitionId}/${parentMarket.resourceName()}`;
			};

			return parentMarket.get().then((result) => {
				set(result.data);
			});
		},

		createParentMarket(data) {
			let parentMarket = new ParentMarket();

			return parentMarket
				.makePersistRequest({
					url: parentMarket.resourceUrl(),
					method: 'PUT',
					data
				})
				.then((result) => {
					return result;
				});
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
